/**
 * @fileoverview POST handler for the "/engagement/landing_pages/:app_group_id/create" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementLandingPagesAppGroupIdLandingPageIdCacheKeys } from "./constants";
import type {
  PostEngagementLandingPagesAppGroupIdLandingPageIdProps,
  EngagementLandingPagesAppGroupIdLandingPagePostIdResult,
} from "./types";

export const postEngagementLandingPagesAppGroupIdLandingPageId = reactQueryMutationAdapter(
  engagementLandingPagesAppGroupIdLandingPageIdCacheKeys,
  (
    props: PostEngagementLandingPagesAppGroupIdLandingPageIdProps
  ): Promise<EngagementLandingPagesAppGroupIdLandingPagePostIdResult> => {
    const { app_group_id: appGroupId } = props;
    return fetch(`/engagement/landing_pages/${appGroupId}/create`, "POST", props);
  }
);
